import { render, staticRenderFns } from "./PaceMakerImpiantoViewComponent.vue?vue&type=template&id=60e6dc28"
import script from "./PaceMakerImpiantoViewComponent.vue?vue&type=script&lang=js"
export * from "./PaceMakerImpiantoViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports